// UI Events (initiated by user)
export enum UiEventType {
  FINISH_GAME = 'finish_game',
  ROLLS_CHANGED = 'rolls_changed',
  REWARD_GAINED = 'reward_gained',
  CLAIM_INSTANT_PRIZE = 'claim_instant_prize',
  XP_GAINED = 'xp_gained',
  COLLECTIBLE_GAINED = 'collectible_gained',
  COLLECTIBLE_GAINED_FULL = 'collectible_gained_full',
  ITEM_GAINED = 'item_gained',
  POPUP_REQUESTED = 'popup_requested',
  COMPLETE_MILESTONE = 'complete_milestone',
}
